import React from 'react'
import PropTypes, { oneOfType } from 'prop-types'

import { pick } from '@styled-system/props'

import { Icon } from 'Components/UI'

// Deep import, not the barrel. `Assets/_Legacy/BlockchainPage/index.ts`
// re-exports 12 svgr-compiled SVGs (~812 KB of JSX, of which highDemand
// alone is 303 KB). FlyingCube is re-exported from the Blocks/_Legacy
// barrel, so pulling the glyph through the assets barrel put all 12 on
// every route that imports any legacy block -- /blog, /work/[slug],
// and /cto -- none of which render a blockchain page.
import flyingCubeGlyph from 'Assets/_Legacy/BlockchainPage/flyingCube.svg'

import { Container } from './styles'

function FlyingCube({
  size = 50,
  rotateAngle = 0,
  desktopOnly = false,
  ...rest
}) {
  return (
    <Container
      {...pick(rest)}
      display={[
        'none',
        'none',
        'none',
        !desktopOnly ? 'block' : 'none',
        !desktopOnly ? 'block' : 'none',
        !desktopOnly ? 'block' : 'none',
        'block',
      ]}
      rotateAngle={rotateAngle}
    >
      <Icon glyph={flyingCubeGlyph} size={size} />
    </Container>
  )
}

FlyingCube.propTypes = {
  desktopOnly: PropTypes.bool,
  rotateAngle: PropTypes.number,
  size: oneOfType([PropTypes.number, PropTypes.array]),
}

export default FlyingCube
